var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTesla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_3103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1266 39.9215L25.7412 8.4422C31.0869 8.4422 32.7792 9.02603 33.0164 11.4087C33.0164 11.4087 36.6066 10.0674 38.4095 7.36922C31.3558 4.10295 24.2545 3.96094 24.2545 3.96094L20.1108 8.99447H20.1266L15.9988 3.96094C15.9988 3.96094 8.89753 4.10295 1.84375 7.36922C3.64673 10.0832 7.23689 11.4087 7.23689 11.4087C7.47412 9.02603 9.1664 8.4422 14.4805 8.42642L20.1266 39.9215Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1265 2.51006C25.836 2.46272 32.3678 3.39369 39.0579 6.29704C39.9594 4.68757 40.1808 3.97751 40.1808 3.97751C32.8739 1.08994 26.0258 0.111636 20.1265 0.0800781C14.2431 0.111636 7.39492 1.08994 0.0722656 3.97751C0.0722656 3.97751 0.404395 4.84536 1.19518 6.29704C7.8852 3.37791 14.4171 2.46272 20.1265 2.51006Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_3103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.2667,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesla);
export default __webpack_public_path__ + "static/media/tesla.44b8af947d83c1a6329879107a7639ca.svg";
export { ForwardRef as ReactComponent };